import { useDocumentTitle } from './useDocumentTitle';
import { buildTitle } from './page-title';

/**
 * Sets `document.title` to `Part · Part · Brand` and puts the previous title back when the parts change or the page unmounts.
 * Pass `null` to leave the title to someone else (the open workspace of another organization sets its own). The brand name comes
 * from the caller: this package may not read the app's brand config.
 */
export function usePageTitle(parts: readonly (string | null | undefined)[] | null, brandName: string): void {
  useDocumentTitle(parts ? buildTitle(parts, brandName) : null);
}
